import { render, staticRenderFns } from "./DeleteTierAction.vue?vue&type=template&id=240d43a6&"
import script from "./DeleteTierAction.vue?vue&type=script&lang=js&"
export * from "./DeleteTierAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports